import React, { ReactNode } from 'react';
import MuiIconButton from '@mui/material/IconButton';

type IconButtonProps = {
  onClick: () => void;
  icon: ReactNode;
  label?: string;
};

export const IconButton: React.FC<IconButtonProps> = ({
  onClick,
  icon,
  label,
}) => {
  return (
    <MuiIconButton
      type='button'
      aria-label={label}
      title={label}
      onClick={onClick}
      size="small"
      sx={{
        width: { xs: 32, sm: 36 },
        height: { xs: 32, sm: 36 },
        flexShrink: 0,
        borderRadius: '6px',
        border: '1px solid',
        borderColor: '#e2e8f0',
        bgcolor: '#ffffff',
        p: { xs: 0.75, sm: 1 },
        color: '#334155',
        transition: 'all 0.2s ease',
        '&:hover': {
          borderColor: '#34d399',
          bgcolor: '#ecfdf5',
          color: '#047857',
        },
      }}
    >
      {icon}
    </MuiIconButton>
  );
};
